import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../context';
import { BaseSelector } from '../../../../models/baseSelector';
import { InterruptionTypeModelAPI } from '../../../../models';
import AsyncSelect from 'react-select/async';
interface Props {
    name: string;
    disable?: boolean;
    onChange: (name: string, value: string | null | number | undefined) => void;
    value: string | undefined | number;
    label: string;
}

export const InterruptionSelector = ({
    name,
    onChange,
    disable = false,
    value,
    label,
}: Props) => {
    const {
        langResources,
        interruptionReferenceTypesList,
        interruptionTypesByUserList,
    } = useContext(AppContext);

    const [dataList, setDataList] = useState<BaseSelector[]>([]);
    const [isLoadingData, setIsLoadingData] = useState(true);

    useEffect(() => {
        const convertedResponse = interruptionTypesByUserList.map(
            (item: InterruptionTypeModelAPI) => {
                return {
                    label: item.name,
                    value: item.id,
                };
            }
        );
        setIsLoadingData(false);
        setDataList(convertedResponse);
    }, []);

    const filterName = (inputValue: string) => {
        return dataList.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadOptions = (
        inputValue: string,
        callback: (options: BaseSelector[]) => void
    ) => {
        setTimeout(() => {
            callback(filterName(inputValue));
        }, 1000);
    };

    return (
        <>
            {label.trim() !== '' && <label>{label}:</label>}
            <AsyncSelect
                isLoading={isLoadingData}
                onChange={(e) => {
                    onChange(name, e?.value);
                }}
                cacheOptions
                loadOptions={loadOptions}
                defaultOptions={dataList}
                name='interruptions-by-user-selector'
                placeholder={
                    langResources['create.interruption.Modal'][
                        'select.interruptions.placeholder'
                    ]
                }
                className='flex-1'
                isDisabled={disable}
                value={
                    dataList.find((a) => a.value === value) ?? {
                        label: langResources['create.interruption.Modal'][
                            'select.interruptions.placeholder'
                        ],
                        value: 0,
                    }
                }
            />
        </>
    );
};
